let IsDevEnvironment =
    (window.location.host.toLowerCase().indexOf("-dev") > -1) ||
    (window.location.host.toLowerCase().indexOf("localhost") > -1)

let FullAuthUrl = IsDevEnvironment
    ? process.env.REACT_APP_FULL_AUTH_URL_DEV
    : process.env.REACT_APP_FULL_AUTH_URL_PROD;

let LabSimAppUrl = IsDevEnvironment
    ? process.env.REACT_APP_LABSIMAPP_URL_DEV
    : process.env.REACT_APP_LABSIMAPP_URL_PROD;

export { IsDevEnvironment, FullAuthUrl, LabSimAppUrl }